import { useState, useCallback } from "react";

function getCredentials() {
  const credentialsString = localStorage.getItem("credentials");
  return credentialsString && JSON.parse(credentialsString);
}

function saveСredentials(credentials) {
  if (credentials)
    localStorage.setItem("credentials", JSON.stringify(credentials));
  else
    localStorage.removeItem("credentials");
}

/**
 * Хук. Использование данных авторизации, сохранённых в localStorage.
 * @return объект с полями setCredentials, saveCredentials, credentials
 */
export default function useCredentials() {
  const [credentials, setСredentials] = useState(getCredentials());
  const setAndSaveCredentials = useCallback((credentials) => {
    saveСredentials(credentials);
    setСredentials(credentials);
  }, [setСredentials]);
  return {
    setCredentials: setAndSaveCredentials,
    saveСredentials,
    credentials,
  };
}
